import { PATRON_CONTRASENA } from 'src/utils/patronesValidacion';
import * as Yup from 'yup';

export const valoresInicialesRecuperarContrasena = {
	correo: '',
	contrasena: '',
	confirmarContrasena: '',
};

export const esquemaDeValidacionRecuperarContrasena = Yup.object().shape({
	contrasena: Yup.string()
	.matches(
		PATRON_CONTRASENA,
		'La contraseña debe tener al menos 8 caracteres que incluyan mayúsculas, minúsculas, números y un carácter no alfanumérico'
	)
		.required('La contraseña es requerida'),
	confirmarContrasena: Yup.string()
		.oneOf([Yup.ref('contrasena'), undefined], 'Las contraseñas deben coincidir')
		.required('Debes confirmar la contraseña'),
});
